<div class="episode-panel flex justify-content-between align-items-center" [ngClass]="{ 'no-hover-effect': !showHover }">
    <div>
        <div
            *ngFor="let diag of diagnosis; let k = index">
            <b>{{ diag.diagnosisName }}</b>
            <i class="pi pi-minus ml-1 mr-1 fs-red"></i>
            <ng-container>{{ diag.diagnosisBodyPartName }}</ng-container> <i class="pi pi-minus ml-1 mr-1 fs-red"></i>
            <ng-container>{{ diag.bodySide }}</ng-container>
            <ng-container *ngIf="diag.diagnosisMedicalSystemName">
                <i class="pi pi-minus ml-1 mr-1 fs-red"></i> {{ diag.diagnosisMedicalSystemName }}
            </ng-container>
        </div>
    </div>
    <div class="flex align-items-center">
        <button
            doNotPropagateClick
            pButton
            pRipple
            type="button"
            icon="mi mi-info"
            class="p-button-secondary p-button-rounded p-button-text"
            (click)="episodeInfo.toggle($event)"></button>
        <button *ngIf="showViewButton" pButton type="button" class="ml-3 p-button-secondary">View</button>
        <p-overlayPanel #episodeInfo appendTo="body">

            <div  *ngFor="let diagnose of diagnosis">
                <m-diagnosis-badge class="diagnosis-code-icon" [isOSIICSCode]="diagnose.diagnosisIsOSIICSCode"></m-diagnosis-badge>
                <span class="diagnosis-info">{{diagnose.diagnosisCode}} </span> 
            </div>

            <m-user-initials
                *ngIf="episode.assignedClinicianUserId"
                header="Assigned Clinician:"
                [title]="episode.assignedClinicianUserTitle"
                [fullName]="episode.assignedClinicianUserFullName"
                [role]="episode.assignedClinicianUserRole"
                circleStyleClass="created-by"></m-user-initials>

            <m-user-initials
                [header]="createdDateInfo"
                [title]="episode.userTitle"
                [fullName]="episode.userFullName"
                [role]="episode.userRole"
                circleStyleClass="created-by"></m-user-initials>
            <m-user-initials
                *ngIf="episode.modifiedUserId"                
                [header]="updatedDateInfo"
                [title]="episode.modifiedUserTitle"
                [fullName]="episode.modifiedUserFullName"
                [role]="episode.modifiedUserRole"
                circleStyleClass="updated-by"></m-user-initials>
        </p-overlayPanel>
    </div>
</div>
